// Copyright The OpenTelemetry Authors
// SPDX-License-Identifier: Apache-2.0

import CartIcon from '../CartIcon';
import CurrencySwitcher from '../CurrencySwitcher';
import * as S from './Header.styled';

const categories = [
  { label: 'Telescopes', slug: 'telescopes' },
  { label: 'Binoculars', slug: 'binoculars' },
  { label: 'Solar', slug: 'solar' },
  { label: 'Accessories', slug: 'accessories' },
  { label: 'Books', slug: 'books' },
];

const Header = () => {
  return (
    <S.Header>
      <S.NavBar>
        <S.Container>
          <S.LeftGroup>
            <S.NavBarBrand href="/">
              <S.BrandLogo />
            </S.NavBarBrand>
            <S.NavLinks>
              {categories.map(({ label, slug }) => (
                <S.NavLink key={slug} href={`/?category=${slug}#shop`}>
                  {label}
                </S.NavLink>
              ))}
            </S.NavLinks>
          </S.LeftGroup>
          <S.Controls>
            <CurrencySwitcher />
            <CartIcon />
          </S.Controls>
        </S.Container>
      </S.NavBar>
    </S.Header>
  );
};

export default Header;
